var map = {
	"./book": 8804,
	"./book.js": 8804,
	"./bookInfo": 4545,
	"./bookInfo.js": 4545,
	"./congratulations": 570,
	"./congratulations.js": 570,
	"./storyBook1/storyBook1": 8903,
	"./storyBook1/storyBook1.json": 8903,
	"./storyBook1/storybook1 Images/Storybook1_Slide10Image.png": 4377,
	"./storyBook1/storybook1 Images/Storybook1_Slide11Image.png": 1998,
	"./storyBook1/storybook1 Images/Storybook1_Slide12Image.png": 4146,
	"./storyBook1/storybook1 Images/Storybook1_Slide13Image.png": 8647,
	"./storyBook1/storybook1 Images/Storybook1_Slide14Image.png": 5407,
	"./storyBook1/storybook1 Images/Storybook1_Slide15Image.png": 7702,
	"./storyBook1/storybook1 Images/Storybook1_Slide16Image.png": 1046,
	"./storyBook1/storybook1 Images/Storybook1_Slide17Image.png": 4531,
	"./storyBook1/storybook1 Images/Storybook1_Slide18Image.png": 5986,
	"./storyBook1/storybook1 Images/Storybook1_Slide19Image.png": 2883,
	"./storyBook1/storybook1 Images/Storybook1_Slide1Image.png": 9755,
	"./storyBook1/storybook1 Images/Storybook1_Slide20Image.png": 76,
	"./storyBook1/storybook1 Images/Storybook1_Slide21Image.png": 937,
	"./storyBook1/storybook1 Images/Storybook1_Slide22Image.png": 8665,
	"./storyBook1/storybook1 Images/Storybook1_Slide23Image.png": 3956,
	"./storyBook1/storybook1 Images/Storybook1_Slide24Image.png": 7969,
	"./storyBook1/storybook1 Images/Storybook1_Slide25Image.png": 6767,
	"./storyBook1/storybook1 Images/Storybook1_Slide26Image.png": 4946,
	"./storyBook1/storybook1 Images/Storybook1_Slide27Image.png": 2630,
	"./storyBook1/storybook1 Images/Storybook1_Slide28Image.png": 1194,
	"./storyBook1/storybook1 Images/Storybook1_Slide29Image.png": 7590,
	"./storyBook1/storybook1 Images/Storybook1_Slide30Image.png": 2349,
	"./storyBook1/storybook1 Images/Storybook1_Slide31Image.png": 5855,
	"./storyBook1/storybook1 Images/Storybook1_Slide32Image.png": 9198,
	"./storyBook1/storybook1 Images/Storybook1_Slide33Image.png": 7839,
	"./storyBook1/storybook1 Images/Storybook1_Slide34Image.png": 7004,
	"./storyBook1/storybook1 Images/Storybook1_Slide35Image.png": 8959,
	"./storyBook1/storybook1 Images/Storybook1_Slide36Image.png": 8,
	"./storyBook1/storybook1 Images/Storybook1_Slide37Image.png": 6413,
	"./storyBook1/storybook1 Images/Storybook1_Slide38Image.png": 1038,
	"./storyBook1/storybook1 Images/Storybook1_Slide39Image.png": 9578,
	"./storyBook1/storybook1 Images/Storybook1_Slide3Image.png": 5727,
	"./storyBook1/storybook1 Images/Storybook1_Slide40Image.png": 5430,
	"./storyBook1/storybook1 Images/Storybook1_Slide41Image.png": 5056,
	"./storyBook1/storybook1 Images/Storybook1_Slide42Image.png": 926,
	"./storyBook1/storybook1 Images/Storybook1_Slide43Image.png": 4561,
	"./storyBook1/storybook1 Images/Storybook1_Slide44Image.png": 7244,
	"./storyBook1/storybook1 Images/Storybook1_Slide45Image.png": 9,
	"./storyBook1/storybook1 Images/Storybook1_Slide46Image.png": 7206,
	"./storyBook1/storybook1 Images/Storybook1_Slide47Image.png": 261,
	"./storyBook1/storybook1 Images/Storybook1_Slide48Image.png": 5714,
	"./storyBook1/storybook1 Images/Storybook1_Slide49Image.png": 5607,
	"./storyBook1/storybook1 Images/Storybook1_Slide4Image.png": 4439,
	"./storyBook1/storybook1 Images/Storybook1_Slide50Image.png": 3603,
	"./storyBook1/storybook1 Images/Storybook1_Slide51Image.png": 8955,
	"./storyBook1/storybook1 Images/Storybook1_Slide5Image.png": 7317,
	"./storyBook1/storybook1 Images/Storybook1_Slide6Image.png": 5307,
	"./storyBook1/storybook1 Images/Storybook1_Slide7Image.png": 5410,
	"./storyBook1/storybook1 Images/Storybook1_Slide8Image.png": 7782,
	"./storyBook1/storybook1 Images/Storybook1_Slide9Image.png": 802,
	"./storyBook2/storyBook2": 5369,
	"./storyBook2/storyBook2.json": 5369,
	"./storyBook2/storybook2 Images/Storybook2_Slide10Image.png": 7574,
	"./storyBook2/storybook2 Images/Storybook2_Slide11Image.png": 6417,
	"./storyBook2/storybook2 Images/Storybook2_Slide12Image.png": 2963,
	"./storyBook2/storybook2 Images/Storybook2_Slide13Image.png": 4622,
	"./storyBook2/storybook2 Images/Storybook2_Slide14Image.png": 2507,
	"./storyBook2/storybook2 Images/Storybook2_Slide15Image.png": 7634,
	"./storyBook2/storybook2 Images/Storybook2_Slide16Image.png": 2368,
	"./storyBook2/storybook2 Images/Storybook2_Slide17Image.png": 3264,
	"./storyBook2/storybook2 Images/Storybook2_Slide18Image.png": 682,
	"./storyBook2/storybook2 Images/Storybook2_Slide19Image.png": 8003,
	"./storyBook2/storybook2 Images/Storybook2_Slide20Image.png": 3114,
	"./storyBook2/storybook2 Images/Storybook2_Slide21Image.png": 9952,
	"./storyBook2/storybook2 Images/Storybook2_Slide22Image.png": 7628,
	"./storyBook2/storybook2 Images/Storybook2_Slide23Image.png": 6396,
	"./storyBook2/storybook2 Images/Storybook2_Slide24Image.png": 770,
	"./storyBook2/storybook2 Images/Storybook2_Slide25Image.png": 5242,
	"./storyBook2/storybook2 Images/Storybook2_Slide26Image.png": 1308,
	"./storyBook2/storybook2 Images/Storybook2_Slide27Image.png": 7483,
	"./storyBook2/storybook2 Images/Storybook2_Slide28Image.png": 3101,
	"./storyBook2/storybook2 Images/Storybook2_Slide29Image.png": 9598,
	"./storyBook2/storybook2 Images/Storybook2_Slide30Image.png": 6038,
	"./storyBook2/storybook2 Images/Storybook2_Slide31Image.png": 722,
	"./storyBook2/storybook2 Images/Storybook2_Slide32Image.png": 3186,
	"./storyBook2/storybook2 Images/Storybook2_Slide33Image.png": 5764,
	"./storyBook2/storybook2 Images/Storybook2_Slide34Image.png": 9714,
	"./storyBook2/storybook2 Images/Storybook2_Slide35Image.png": 8770,
	"./storyBook2/storybook2 Images/Storybook2_Slide36Image.png": 9490,
	"./storyBook2/storybook2 Images/Storybook2_Slide37Image.png": 8023,
	"./storyBook2/storybook2 Images/Storybook2_Slide38Image.png": 3068,
	"./storyBook2/storybook2 Images/Storybook2_Slide39Image.png": 4367,
	"./storyBook2/storybook2 Images/Storybook2_Slide3Image.png": 5178,
	"./storyBook2/storybook2 Images/Storybook2_Slide40Image.png": 567,
	"./storyBook2/storybook2 Images/Storybook2_Slide41Image.png": 2817,
	"./storyBook2/storybook2 Images/Storybook2_Slide42Image.png": 7679,
	"./storyBook2/storybook2 Images/Storybook2_Slide43Image.png": 694,
	"./storyBook2/storybook2 Images/Storybook2_Slide44Image.png": 5163,
	"./storyBook2/storybook2 Images/Storybook2_Slide45Image.png": 2583,
	"./storyBook2/storybook2 Images/Storybook2_Slide46Image.png": 4069,
	"./storyBook2/storybook2 Images/Storybook2_Slide47Image.png": 7841,
	"./storyBook2/storybook2 Images/Storybook2_Slide48Image.png": 5832,
	"./storyBook2/storybook2 Images/Storybook2_Slide49Image.png": 744,
	"./storyBook2/storybook2 Images/Storybook2_Slide4Image.png": 7832,
	"./storyBook2/storybook2 Images/Storybook2_Slide50Image.png": 2759,
	"./storyBook2/storybook2 Images/Storybook2_Slide51Image.png": 6987,
	"./storyBook2/storybook2 Images/Storybook2_Slide52Image.png": 1044,
	"./storyBook2/storybook2 Images/Storybook2_Slide5Image.png": 2355,
	"./storyBook2/storybook2 Images/Storybook2_Slide6Image.png": 3546,
	"./storyBook2/storybook2 Images/Storybook2_Slide7Image.png": 6429,
	"./storyBook2/storybook2 Images/Storybook2_Slide8Image.png": 6958,
	"./storyBook2/storybook2 Images/Storybook2_Slide9Image.png": 4859,
	"./survey": 7517,
	"./survey.js": 7517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2968;